(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jc-shoe-support"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jc-shoe-size-finder')) {
  customElements.define('jc-shoe-size-finder', class extends HTMLElement {
    static measurements = new Map();
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.initialize(); });
    }
    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('change', this.onInput);
      this.accordion?.removeEventListener('toggle', this.onToggle);
      this.form?.removeEventListener('product:rerender', this.onRerender, true);
    }
    normalize(value) {
      return value.toLowerCase().replace(/[^a-z]/g, '');
    }
    number(value, size = false) {
      let text = value.trim().replace(/,/g, '.');
      if (size) text = text.replace(/^UK\s*/i, '').replace(/\s*½$/, '.5').replace(/\s+1\/2$/, '.5');
      else text = text.replace(/\s*cm$/i, '').trim();
      return /^\d+(?:\.\d+)?$/.test(text) ? Number(text) : NaN;
    }
    readChart(table) {
      const rows = Array.from(table.rows, row => Array.from(row.cells, cell => cell.textContent.trim()));
      const isUK = value => /^(uk|uksize|uksizes|sizeuk|sizesuk)$/.test(this.normalize(value));
      const isCM = value => /^(cm|lengthcm|footlengthcm|footlengthincm|footlengthcentimetres|footlengthcentimeters|heeltotoecm)$/.test(this.normalize(value));
      let pairs = [];
      const header = rows.findIndex(row => row.some(isUK) && row.some(isCM));
      if (header >= 0) {
        const uk = rows[header].findIndex(isUK), cm = rows[header].findIndex(isCM);
        pairs = rows.slice(header + 1).filter(row => row.some(value => value !== '')).map(row => [row[uk] || '', row[cm] || '']);
      } else {
        const uk = rows.find(row => isUK(row[0] || '')), cm = rows.find(row => isCM(row[0] || ''));
        if (uk && cm && uk.length === cm.length) pairs = uk.slice(1).map((value, index) => [value, cm[index + 1]]);
      }
      const chart = pairs.map(([size, length]) => ({size: this.number(size, true), cm: this.number(length)})).sort((a, b) => a.cm - b.cm);
      if (chart.length < 2 || chart.some((row, index) => !Number.isFinite(row.size) || !Number.isFinite(row.cm) || row.size <= 0 || row.cm < 5 || row.cm > 50 || (index > 0 && (row.cm <= chart[index - 1].cm || row.size <= chart[index - 1].size)))) return null;
      return chart;
    }
    initialize() {
      this.input = this.querySelector('[data-fit-length]');
      this.result = this.querySelector('[data-fit-result]');
      this.note = this.querySelector('[data-fit-note]');
      this.accordion = this.closest('details');
      const source = this.querySelector('[data-fit-chart]')?.content;
      if (!source || !this.input || !this.result || !this.note) return;
      const charts = Array.from(source.querySelectorAll('table'), table => this.readChart(table)).filter(Boolean);
      const unique = [...new Map(charts.map(chart => [JSON.stringify(chart), chart])).values()];
      if (unique.length !== 1) return;
      this.chart = unique[0];
      this.readSizes(this.querySelector('[data-fit-sizes]'));
      this.form = document.getElementById(this.closest('product-rerender')?.getAttribute('observe-form'));
      this.onRerender = event => {
        const updated = Array.from(event.detail?.htmlFragment?.querySelectorAll('jc-shoe-size-finder') || []).find(item => item.dataset.productId === this.dataset.productId);
        if (updated) {
          this.readSizes(updated.querySelector('[data-fit-sizes]'));
          this.recommend();
        }
      };
      this.form?.addEventListener('product:rerender', this.onRerender, true);
      this.input.min = String(this.chart[0].cm);
      this.input.max = String(this.chart[this.chart.length - 1].cm);
      this.onInput = () => {
        this.constructor.measurements.set(this.dataset.productId, {value: this.input.value, open: this.accordion?.open});
        this.recommend();
      };
      this.onToggle = () => this.constructor.measurements.set(this.dataset.productId, {value: this.input.value, open: this.accordion?.open});
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('change', this.onInput);
      this.accordion?.addEventListener('toggle', this.onToggle);
      const previous = this.constructor.measurements.get(this.dataset.productId);
      if (previous) {
        this.input.value = previous.value;
        if (this.accordion) this.accordion.open = previous.open;
      }
      this.hidden = false;
      const fallback = this.accordion?.querySelector('[data-fit-fallback]');
      if (fallback) fallback.hidden = true;
      this.recommend();
    }
    readSizes(template) {
      const sizes = Array.from(template?.content.querySelectorAll('[data-size-label]') || []).filter(item => /^(size|sizes|uk|uksize|ukshoesize|shoesize|sizeuk|sizesuk)$/.test(this.normalize(item.dataset.optionName)));
      this.offered = new Set(sizes.map(item => this.number(item.dataset.sizeLabel, true)).filter(Number.isFinite));
      this.available = new Set(sizes.filter(item => item.dataset.available === 'true').map(item => this.number(item.dataset.sizeLabel, true)).filter(Number.isFinite));
    }
    recommend() {
      this.note.hidden = true;
      this.input.removeAttribute('aria-invalid');
      if (this.input.validity.badInput) {
        this.result.textContent = this.dataset.invalid;
        this.input.setAttribute('aria-invalid', 'true');
        return;
      }
      if (!this.input.value.trim()) {
        this.result.textContent = this.dataset.initial;
        return;
      }
      const length = this.number(this.input.value);
      if (!Number.isFinite(length) || length <= 0) {
        this.result.textContent = this.dataset.invalid;
        this.input.setAttribute('aria-invalid', 'true');
        return;
      }
      const first = this.chart[0], last = this.chart[this.chart.length - 1];
      if (length < first.cm || length > last.cm) {
        this.result.textContent = this.dataset.outside;
        this.input.setAttribute('aria-invalid', 'true');
        return;
      }
      const match = this.chart.find(row => row.cm >= length);
      this.result.textContent = this.dataset.recommendation.replace('{size}', String(match.size));
      this.note.hidden = false;
      const reason = Math.abs(match.cm - length) < 0.00001 ? this.dataset.exact : this.dataset.between;
      if (!this.offered.size) {
        this.note.textContent = reason;
        return;
      }
      if (this.available.has(match.size)) {
        this.note.textContent = reason;
        return;
      }
      const alternatives = this.chart.filter(row => this.available.has(row.size)).sort((a, b) => {
        const distance = Math.abs(a.cm - match.cm) - Math.abs(b.cm - match.cm);
        return Math.abs(distance) < 0.00001 ? b.cm - a.cm : distance;
      });
      if (!alternatives.length) {
        this.note.textContent = this.dataset.noneAvailable;
        return;
      }
      const closest = alternatives[0];
      this.result.textContent = this.dataset.closest.replace('{size}', String(closest.size));
      this.note.textContent = this.dataset.alternative.replace('{size}', String(match.size)).replace('{cm}', String(closest.cm));
    }
  });
}

if (!customElements.get('jc-shoe-delivery')) {
  customElements.define('jc-shoe-delivery', class extends HTMLElement {
    connectedCallback() {
      this.onChange = () => this.updateEstimate();
      this.addEventListener('change', this.onChange);
      this.updateEstimate();
    }
    disconnectedCallback() { this.removeEventListener('change', this.onChange); }
    updateEstimate() {
      const priority = this.querySelector('input[value="priority"]').checked;
      this.querySelectorAll('[data-service]').forEach(item => { item.hidden = item.dataset.service !== (priority ? 'priority' : 'standard'); });
      if (this.dataset.state !== 'ready') return;
      const parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const part = key => Number(parts.find(item => item.type === key).value);
      const today = new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
      const addBusinessDays = (date, count) => {
        const result = new Date(date);
        while (count > 0) { result.setUTCDate(result.getUTCDate() + 1); if (![0,6].includes(result.getUTCDay())) count--; }
        return result;
      };
      const format = date => new Intl.DateTimeFormat('en-GB', {day:'numeric',month:'short',timeZone:'UTC'}).format(date);
      const range = (min, max) => `${format(addBusinessDays(today,min))} – ${format(addBusinessDays(today,max))}`;
      this.querySelector('[data-ordered]').textContent = format(today);
      this.querySelector('[data-dispatch]').textContent = range(1,3);
      this.querySelector('[data-arrival]').textContent = priority ? range(6,10) : range(8,15);
    }
  });
}
if (!customElements.get('jc-shoe-sticky')) {
  customElements.define('jc-shoe-sticky', class extends HTMLElement {
    connectedCallback() {
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateVisibility(); });
      };
      window.addEventListener('scroll', this.schedule, {passive:true});
      window.addEventListener('resize', this.schedule);
      document.addEventListener('variant:change', this.schedule);
      this.schedule();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      document.removeEventListener('variant:change', this.schedule);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
    updateVisibility() {
      const form = document.getElementById(this.getAttribute('main-product-form'));
      const footer = document.querySelector('.shopify-section--footer');
      const isPastForm = form && form.getBoundingClientRect().bottom < 0;
      const isBeforeFooter = !footer || footer.getBoundingClientRect().top > window.innerHeight;
      this.classList.toggle('is-visible', Boolean(isPastForm && isBeforeFooter));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
